import React from 'react';
import { Modal } from 'react-bootstrap';

import FittingBatchListContainer from '../containers/FittingBatchListContainer.jsx';
import FittingBatchEditContainer from '../containers/FittingBatchEditContainer.jsx';

export default class FittingBatchComponent extends React.Component {

  componentDidMount() {
  }

  render() {
    return (
      <div>
        <div style={{marginTop: 10}}>
          <FittingBatchListContainer orderId={this.props.orderId} />
        </div>
        <Modal show={this.props.showFittingBatchModal} onHide={this.props.closeModal} backdrop="static">
          <Modal.Header closeButton />
          <Modal.Body>
            <FittingBatchEditContainer />
          </Modal.Body>
        </Modal>
      </div>
    )
  }
};


// WEBPACK FOOTER //
// ./src/components/FittingBatchComponent.jsx